import { useCookies } from 'react-cookie';

export const useShouldSuppressPushPrompt = () => {
  const [cookies] = useCookies();
  return !!cookies['suppress-push-prompt'];
};
